import { LocationData } from '../types';

// Single source of truth for the onboarding step completion state, shared by the
// SetupChecklist banner and the GuidedTour tooltip so their counts never drift.
export interface SetupStepMeta {
  id: string;
  label: string;
  done: boolean;
}

export function getSetupSteps(location: LocationData | null | undefined): SetupStepMeta[] {
  if (!location) return [];
  const allRacks = Object.values(location.floors ?? {}).flatMap(f => f.racks ?? []);
  return [
    { id: 'supplier',   label: 'Choose a power supplier',              done: !!location.selectedPowerSupplierId },
    { id: 'transformer', label: 'Install Transformer',                 done: !!location.transformer },
    { id: 'powerhouse', label: 'Install Power Distribution',           done: !!location.powerhouse?.installed },
    { id: 'ups',        label: 'Install UPS',                          done: !!location.ups?.installed },
    { id: 'cooling',    label: 'Build Cooling Chain',                  done: (location.totalCoolingCapacityKW || 0) > 0 },
    { id: 'rack',       label: 'Purchase your first rack',             done: allRacks.some(r => r.type) },
    { id: 'mpo',        label: 'Install an MPO patch panel',           done: allRacks.some(r => r.mpoPatchPanel) },
    { id: 'tor',        label: 'Install a TOR switch',                 done: allRacks.some(r => r.torSwitch) },
    { id: 'mmr',        label: 'Build the Meet-Me Room',               done: !!location.mmr?.built },
    { id: 'coreswitch', label: 'Install a Core Switch',                done: !!location.coreSwitch },
    { id: 'transit',    label: 'Connect to a transit provider or IXP', done:
        (location.mmr?.transitProviders ?? []).length > 0 || (location.mmr?.ixpConnections ?? []).length > 0 },
  ];
}

export interface SetupProgress {
  done: number;
  total: number;
  complete: boolean;
  nextLabel: string | null;
  nextIndex: number; // 1-based index of the current step (total+1 when complete)
}

export function getSetupProgress(location: LocationData | null | undefined): SetupProgress {
  const steps = getSetupSteps(location);
  const done = steps.filter(s => s.done).length;
  const nextIdx = steps.findIndex(s => !s.done);
  return {
    done,
    total: steps.length,
    complete: steps.length > 0 && done === steps.length,
    nextLabel: nextIdx >= 0 ? steps[nextIdx].label : null,
    nextIndex: nextIdx >= 0 ? nextIdx + 1 : steps.length + 1,
  };
}
